export default __webpack_public_path__ + "static/media/vertical3.f52f919c.JPG";